import { render, staticRenderFns } from "./FavRatingsBeta.vue?vue&type=template&id=d329f738&"
import script from "./FavRatingsBeta.vue?vue&type=script&lang=js&"
export * from "./FavRatingsBeta.vue?vue&type=script&lang=js&"
import style0 from "./FavRatingsBeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports